export enum EnOrder {
    Asc,
    Desc
}

export class OrderField {
    public order: EnOrder;
    public fieldname :string;
}

export class OrderFilterBase {
    public orderFields: OrderField[]; 
}
